export class CommandeDetail {

    id: number;
    msisdn: string;
    montant: number;
    libelle: string;
    codeOracle: string;
    quantite: number;
    idProduit: number;
    commande: any;
    referencePayement: any;
    categorie: string;

    tauxEchange : number;
    pue: number;
    montantDepot: number;

    debutSerie: string;
    finSerie: string;
    series: string;

    constructor() { }
}
